import { Box } from "@mui/material";
import Header from "../../components/Header";
import MyCustomers from "./dashboard-components/my-customers";
import LicenseSold from "./dashboard-components/license_selled";
import OnlineLecs from "./dashboard-components/onlineLecs";
import { useState, useEffect } from "react";
import API from "../../api/index";
import { Grid } from "@mui/material";
import ResellerCode from "./dashboard-components/resellerCode";
import LecsTable from "./dashboard-components/lecsTable";
import dayjs from "dayjs";

const DashboardR = ({ setCustomerName, setTimeZone, setLecsInfo }) => {
  const [resInfo, setResInfo] = useState({});
  const [countLecs, setCountLecs] = useState(0);
  const [lecs, setLecs] = useState([]);

  const tz = sessionStorage.getItem("timezone") || "Europe/Rome";
  const [dateFrom, setdateFrom] = useState(() => dayjs().tz(tz).subtract(3, "day"));
  const [dateTo, setdateTo] = useState(() => dayjs().tz(tz));
  const [dateFilter, setDateFilter] = useState({ dateFrom: dateFrom, dateTo: dateTo });
  

  const handleNewDateChange = (newDateFilter) => {
    setDateFilter(newDateFilter);

    if (!newDateFilter?.dateFrom || !newDateFilter?.dateTo) return;

    const fromDate = dayjs(newDateFilter.dateFrom).tz(tz);
    const toDate = dayjs(newDateFilter.dateTo).tz(tz);

    setdateFrom(fromDate);
    setdateTo(toDate);

  };

  useEffect(() => {
    API.getResellerInfo({}).then((response) => {
      setResInfo(response.data);
    }).catch(() => setResInfo({}));
    API.getOnlineLecs({}).then((res) => {
      const online = res.data.filter((x) => x.online === true).length;
      setCountLecs({online: online, total: res.data.length});
      setLecs(res.data);
      
    }).catch(() => {
      setCountLecs({online: 0, total: 0});
      setLecs([]);
    })
  }, []);

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Header title="RESELLER OVERVIEW" subtitle="" />
      </Box>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <OnlineLecs total={countLecs.total} online={countLecs.online}/>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <LicenseSold licenseSold={resInfo.license_sold} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MyCustomers customers={resInfo.customers} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <ResellerCode resCode={resInfo.resCode}/>
        </Grid>

        <Grid size={12}>
          <LecsTable
            lecs={lecs}
            setTimeZone={setTimeZone}
            setLecsInfo={setLecsInfo}
            setCustomerName={setCustomerName}
            dateFrom={dateFrom}
            dateTo={dateTo}
            dateFilter={dateFilter}
            onDateChange={handleNewDateChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardR;
